module.exports = __webpack_public_path__ + "static/media/ad-tray-ad-full.67cecbf1.png";